export const sceneNumbers = {
	initMainMenu: 0,
	initIntroduction: 1,
	team2SIntroduction: 9,
	team2SubtopicOne: 10,
	team2SubtopicTwo: 11,
	team2SubtopicThree: 12,
};
